export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    name: other.name || null,
    active: other.active || null,
    geos: other.geos || [] ,
    percentage: other.percentage || null,

  }
}
